export let cognitoConfig = {
    userPool: {
        UserPoolId: 'ap-southeast-2_lDp3Wkm3D',
        ClientId: 'mhev55u7h7rfrijgm5alq8mc1',
        region: 'ap-southeast-2'
    },
    identityPoolId: 'ap-southeast-2:8c228b96-2515-4854-b781-44201be8fc37'
};
